import styled from '@emotion/styled';
import { tokens, Text as HotsauceText } from '@hotjar/hotsauce';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Content = styled.div`
  text-align: center;
`;

export const Title = styled(HotsauceText)`
  ${tokens.text('subtitle1')};
`;

export const Action = styled.div<{ hasExtraPadding?: boolean }>`
  padding-top: ${({ hasExtraPadding }) =>
    hasExtraPadding === true ? tokens.spacer.x2 : tokens.spacer.x1};
`;

export const MoreHelp = styled.div`
  padding-top: ${tokens.spacer.x1};
`;

export const Text = styled(HotsauceText)`
  margin: 0;
`;

export const IconContainer = styled.div`
  display: block;
  margin-bottom: ${tokens.spacer.x3};
`;

// Styles related to new error screens

export const Image = styled.img`
  margin-bottom: ${tokens.spacer.x2pt5};
`;

export const ErrorTitle = styled(Text)`
  margin-bottom: ${tokens.spacer.x0};
`;

export const Subtitle = styled(Text)`
  white-space: pre-line;
`;
